:host {
  --border-head-default: var(--pine-border-width-thin) solid var(--pine-color-background-subtle);

  border-color: inherit;
  box-sizing: border-box;
  display: table-header-group;
  vertical-align: middle;

  // used for pds-checkbox-cell
  // because it is in the ShadowDom
  &::part(checkbox-cell) {
    background-color: var(--pine-color-background-container);
    inset-inline-start: var(--pine-dimension-none);
    position: sticky;
    z-index: var(--pine-z-index-raised);
  }
}

:host pds-table-checkbox-cell {
  border-block-end: var(--border-head-default);
}

:host([border]) {
  border-block-end: var(--pine-border-width-thin) solid var(--pine-color-border-subtle);
  border-block-start: var(--pine-border-width-thin) solid var(--pine-color-border-subtle);
}

:host([border]) pds-table-head-cell {
  border-block-end: var(--pine-border-width-thin) solid var(--pine-color-border-subtle);
  border-block-start: var(--pine-border-width-thin) solid var(--pine-color-border-subtle);
}

:host([background]) {
  background-color: var(--pine-color-background-subtle);
}

:host([background]) pds-table-head-cell {
  background-color: var(--pine-color-background-subtle);
}
